// extracted by mini-css-extract-plugin
var _1 = "UpdatePaymentModalV2_body__x7EDI";
var _2 = "UpdatePaymentModalV2_container__ruCUj";
var _3 = "UpdatePaymentModalV2_header__F5fYH";
var _4 = "UpdatePaymentModalV2_subtitle__ERcxA";
export { _1 as "body", _2 as "container", _3 as "header", _4 as "subtitle" }
